import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FavoriteService } from '../../services/favorites.service'; // Pfad anpassen
import { environment } from '../../../environments/environment'; // Pfad anpassen
import { CommonModule } from '@angular/common';
import { ClrSpinnerModule } from '@clr/angular';

@Component({
  selector: 'app-review',
  standalone: true,
  imports: [CommonModule, ClrSpinnerModule],
  template: `
    <div style="padding: 40px; text-align: center; font-family: sans-serif;">
      <h2>📥 Folien-Vorschlag wird geladen...</h2>
      <p *ngIf="status === 'loading'">Bitte warten, Authentifizierung läuft und Datei wird geholt...</p>
      <clr-spinner *ngIf="status === 'loading'" clrInline></clr-spinner>

      <div *ngIf="status === 'success'" style="color: green; font-weight: bold; margin-top: 20px;">
        ✅ Download erfolgreich gestartet! Du kannst dieses Fenster jetzt schließen.
      </div>

      <div *ngIf="status === 'error'" style="color: red; font-weight: bold; margin-top: 20px;">
        ❌ Fehler beim Herunterladen: {{ errorMessage }}
      </div>
    </div>
  `
})
export class ReviewComponent implements OnInit {
  status: 'loading' | 'success' | 'error' = 'loading';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private favoriteService: FavoriteService
  ) { }

  async ngOnInit() {
    const id = this.route.snapshot.queryParamMap.get('id');

    if (!id) {
      this.status = 'error';
      this.errorMessage = 'Keine ID in der URL gefunden.';
      return;
    }

    try {
      const token = await this.favoriteService.getAccessTokenPromise();

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });

      const apiUrl = `${environment.appConfig.apiEndpoint}/downloadSuggestion?id=${id}`;

      this.http.get(apiUrl, { headers, responseType: 'blob' }).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = `Vorschlag_ID_${id}.pptx`;

          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          window.URL.revokeObjectURL(url);

          this.status = 'success';
        },
        error: (err) => {
          console.error(err);
          this.status = 'error';
          this.errorMessage = 'Du hast keine Berechtigung oder die Datei existiert nicht.';
        }
      });

    } catch (error) {
      console.error('Auth Fehler:', error);
      this.status = 'error';
      this.errorMessage = 'Authentifizierung fehlgeschlagen.';
    }
  }
}
